import { E2_DOMAINS, HOST_NAMES } from './constants';

let retryCount = 0;
export const isPresent = objNm => typeof (objNm) !== 'undefined' && objNm !== '';

export const arrayContains = (objects, element) => {
  let bool = false;
  objects.forEach((ele) => {
    if (element.includes(ele)) {
      bool = true;
    }
  });
  return bool;
};

export const checkDomain = (domainName) => {
  let domainData;
  if (domainName.includes('localhost')) {
    domainData = ['E0', 'localhost', 'http://localhost:9080/gct/'];
  } else if (arrayContains(E2_DOMAINS, window.document.URL)
      && arrayContains(HOST_NAMES, window.location.hostname)) {
    domainData = ['E2', '.americanexpress.com', 'https://gct-qa.americanexpress.com/gct/'];
  } else {
    domainData = ['E3', '.americanexpress.com', 'https://gct.americanexpress.com/gct/'];
  }
  return domainData;
};

export const getReferrerType = (referrer, domains) => {
  let referrerType = 'direct';
  if (typeof (referrer) !== 'undefined' && referrer.length > 0) {
    referrerType = 'external';
    const baseURl = referrer.split('?')[0];
    if (typeof (baseURl) !== 'undefined' && baseURl.length > 0) {
      for (let i = 0; i < domains.length; i += 1) {
        if (baseURl.includes(domains[i])) {
          referrerType = 'internal';
          break;
        }
      }
    }
  }
  return referrerType;
};

export const getSaveAndRetrieveParams = (keys) => {
  const parameters = new Map();
  keys.forEach((key) => {
    if (typeof (window[key]) === 'undefined') {
      parameters.set(`&ret${key}`, '');
    } else {
      parameters.set(`&ret${key}`, `${window[key]}`);
    }
  });
  return parameters;
};

export const retrieveItagData = (itagArray, gctDataArr) => {
  const localGctDataArr = gctDataArr;
  for (let index = 0; index < itagArray.length; index += 1) {
    const val = window[itagArray[index]];
    if (isPresent(val) && !isPresent(gctDataArr[index])) {
      localGctDataArr[index] = val;
    }
  }
  return localGctDataArr;
};

export const retrieveOmnObjData = (omnType, omnArray, gctDataArr) => {
  const localGctDataArr = gctDataArr;
  if (isPresent(window.omn)) {
    for (let index = 0; index < omnArray.length; index += 1) {
      let val = window.omn[omnArray[index]];
      if (isPresent(val) && !isPresent(gctDataArr[index])) localGctDataArr[index] = val;
      else if (index === 1 && isPresent(omnType)) {
        val = window.omn[omnType];
        if (isPresent(val) && !isPresent(gctDataArr[index])) {
          localGctDataArr[index] = val;
        }
      }
    }
  }
  return localGctDataArr;
};
export const retrieveOmnData = (omnType, omnArray, gctDataArr) => {
  const localGctDataArr = gctDataArr;
  for (let index = 0; index < omnArray.length; index += 1) {
    let val = window[omnArray[index]];
    if (isPresent(val) && !isPresent(gctDataArr[index])) localGctDataArr[index] = val;
    else if (index === 1 && isPresent(omnType)) {
      val = window[omnType];
      if (isPresent(val) && !isPresent(gctDataArr[index])) localGctDataArr[index] = val;
    }
  }
  return localGctDataArr;
};

export const formatDt = (dt, delim) => (dt < 10 ? `${delim}0${dt}` : `${delim}${dt}`);
export const formatSec = (tm) => {
  if (tm < 10) return `:00${tm}`;
  if (tm < 100) return `:0${tm}`;
  return `:${tm}`;
};
export const getDate = () => {
  const dt = new Date();
  return dt.getFullYear() + formatDt(dt.getMonth() + 1, '-')
    + formatDt(dt.getDate(), '-') + formatDt(dt.getHours(), '/')
    + formatDt(dt.getMinutes(), ':') + formatDt(dt.getSeconds(), ':')
    + formatSec(dt.getMilliseconds());
};
export const getGuid = () => (((1 + Math.random()) * 0x10000) /* istanbul ignore next */|| 0)
  .toString(16).substring(0, 4);
export const getRandomGuid = () => (`-${getGuid()}${getGuid()}-${getGuid()}-${getGuid()}-${getGuid()}-${getGuid()}${getGuid()}${getGuid()}`);

export const isOneAmex = () => true;
export const isDomestic = () => false;

export const getQsByParam = (name) => {
  const parsedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${parsedName}=([^&#]*)`, 'i');
  const results = regex.exec(window.location.search);
  return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const triggerGCTCall = (refType, pageId) => {
  if (pageId === 'US|AMEX|Home|Homepage') {
    const extLink = getQsByParam('extlink');
    if (typeof extLink !== 'undefined' && extLink !== '') return true;
    return typeof (refType) !== 'undefined' && refType.length > 0 && refType === 'external';
  }
  return true;
};

export const isDTMLoaded = () => {
  let isDTM = false;
  const tags = document.getElementsByTagName('script');
  for (let i = 0; i < tags.length; i += 1) {
    if (tags[i].src.includes('adobedtm')) {
      isDTM = true;
      break;
    }
  }
  return isDTM;
};

export const getDigitalData = (oneAmex) => {
  if ((isPresent(window.digitalData) && oneAmex) || (isPresent(window.digitalData)
    && !oneAmex && isPresent(window.digitalData.page)
    && isPresent(window.digitalData.page.attributes))) {
    return window.digitalData;
  }
  if (retryCount < 3) {
    retryCount += 1;
    setTimeout(getDigitalData(oneAmex), 5000);
  }
  return window.digitalData;
};

export const getOrientation = () => {
  let orientation;
  if (window.document.documentElement.clientHeight > window.document.documentElement.clientWidth) {
    orientation = 'portrait';
  }
  if (window.document.documentElement.clientHeight < window.document.documentElement.clientWidth) {
    orientation = 'landscape';
  }
  return orientation;
};

export const decodeVeidStr = (veidStr) => {
  let localVeidStr = veidStr;
  if (typeof (veidStr) !== 'undefined') {
    for (let ctr = 0; ctr < 3; ctr += 1) {
      try {
        localVeidStr = decodeURIComponent(veidStr);
      } catch (err) {
        /* istanbul ignore else */
        if (veidStr.indexOf('%') >= 0) localVeidStr = veidStr.substring(0, veidStr.lastIndexOf('%'));
      }
    }
    if (localVeidStr.indexOf('%') >= 0) localVeidStr = localVeidStr.substring(0, localVeidStr.lastIndexOf('%'));
  }
  localVeidStr = encodeURIComponent(localVeidStr);
  return localVeidStr;
};
